import { render, staticRenderFns } from "./ProjectDialogSidebar.vue?vue&type=template&id=a0a41dea&"
import script from "./ProjectDialogSidebar.vue?vue&type=script&lang=js&"
export * from "./ProjectDialogSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a41dea')) {
      api.createRecord('a0a41dea', component.options)
    } else {
      api.reload('a0a41dea', component.options)
    }
    module.hot.accept("./ProjectDialogSidebar.vue?vue&type=template&id=a0a41dea&", function () {
      api.rerender('a0a41dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProjectDialogSidebar.vue"
export default component.exports